import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams } from "react-router-dom";
import Report from "../common/Report";
import {
  searchProfiles,
  addToNetwork,
  removeFromNetwork
} from "../../redux/actions/networkActions";
import { report } from "../../redux/actions/userActions";
import "../profile/Profile.scss";

export default function NetworkProfile() {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const profiles = useSelector(state => state.profiles);
  const network = useSelector(state => state.network);
  const { id } = useParams();
  const [profile, setProfile] = useState(
    profiles.find(profile => profile.id == id)
  );
  const [reportReason, setReportReason] = useState("");
  const [isInNetwork, setIsInNetwork] = useState(network.length > 0 &&
    network.find(profile => profile.id == id)
  );

  useEffect(() => {
    if (profiles.length < 1) {
      console.log("no profiles");
      setProfile(loadProfiles().find(profile => profile.id == id));
    } else {
      console.log(profiles);
    }
    if (!profile.name) {
      setProfile(profiles.find(profile => profile.id == id));
      console.log(profile);
    }
  });

  async function loadProfiles() {
    const accessToken = await getAccessTokenSilently();
    await dispatch(searchProfiles(accessToken, "", "Hela Sverige"));
    console.log(profiles);
  }

  async function handleNetworkClick() {
    setIsInNetwork(!isInNetwork);
    if (!isInNetwork) {
      const accessToken = await getAccessTokenSilently();
      dispatch(addToNetwork(accessToken, id)).catch(error => {
        console.log(error);
      });
    } else {
      const accessToken = await getAccessTokenSilently();
      dispatch(removeFromNetwork(accessToken, id)).catch(error => {
        console.log(error);
      });
    }
  }

  function handlReportReasonChange(e) {
    setReportReason(e.target.value);
  }

  async function handleReportSubmit(e) {
    e.preventDefault();
    const accessToken = await getAccessTokenSilently();
    dispatch(report(accessToken, null, profile.id, reportReason)).catch(error => {
      console.log(error);
    });
    window.alert("Tack! Detta har nu skickats in för granskning.");
  }

  return (
    <div className="profile">
      <h2 className="name">{profile.name}</h2>
      <div className="profile-city">
        <span>Stad:</span> {profile.city}
      </div>
      <span className="label">Beskrivning: </span>
      <textarea
        className="profile-description"
        name="description"
        value={profile.description}
        placeholder="Användaren har inte skrivit något än."
        readOnly
      />
      <div className="line"></div>
      <div className="actions">
        <button className="edit" onClick={handleNetworkClick}>
          {isInNetwork
            ? "Ta bort från mitt nätverk"
            : "Lägg till i mitt nätverk"}
        </button>
        <Report
          onChange={handlReportReasonChange}
          onSubmit={handleReportSubmit}
        />
      </div>
    </div>
  );
}
